export const apiRoutes = process.env.REACT_APP_ROUTES
  ? JSON.parse(process.env.REACT_APP_ROUTES)
  : {};
